<template>
  <form @submit.prevent="updateUser">
    <!-- name -->
    <div class="form-group">
      <label for="surname">Name</label>
      <input
        type="text"
        v-model="user.name"
        class="form-control"
        id="surname"
        aria-describedby="surname"
      />
    </div>

    <!-- email -->
    <div class="form-group">
      <label for="othernames">Email</label>
      <input
        type="email"
        v-model="user.email"
        class="form-control"
        id="othernames"
        aria-describedby="othernames"
      />
    </div>

    <!-- roles -->
    <div class="form-group">
      <label for="rolePermission">Roles</label>
      <v-select
        label="name"
        :options="roles"
        v-model="user.roles[0]"
        :reduce="role => role.id"
      ></v-select>
    </div>
    <button type="submit" class="btn btn--secondary" :disabled="isSubmitting">Update User</button>
  </form>
</template>

<script>
export default {
  props: {
    roles: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      user: {},
      isSubmitting: false
    }
  },
  methods: {
    seUserDetails(user) {
      this.user = user
    },
    async updateUser() {
      this.isSubmitting = true
      try {
        const response = await this.$repos.userManagementRepo.updateUser({
          id: this.user.id,
          name: this.user.name,
          email: this.user.email,
          role_id: this.user.roles[0]
        })
        this.showSuccessNotification(response.mesage)
         $('#editUserModal').modal('hide')
      }catch(error) {
        this.showErrorNotification(error.response.data.mesage)
      }finally {
        this.isSubmitting = false
      }
    }
  },
}
</script>